// Contact Page - Simple Design
import React, { useState } from 'react';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';
function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();

    // Create mailto link with form data
    const mailtoSubject = encodeURIComponent(formData.subject || `Contact Form - Message from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`);

    // Open default email client
    window.location.href = `mailto:yphilipos@gmail.com?subject=${mailtoSubject}&body=${body}`;

    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };
  return <div className="min-w-full bg-white">
      <Navigation variant="soft-brown" />
      
      {/* Header */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-sage-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-serif text-5xl md:text-6xl text-sage-800 mb-6">
            Get in Touch
          </h1>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          
          {/* Contact Info Cards */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {/* Email */}
            <div className="bg-sage-50 rounded-2xl p-8 text-center">
              <div className="w-14 h-14 bg-sage-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-serif font-semibold text-sage-800 mb-2">Email</h3>
              <a href="mailto:yphilipos@gmail.com" className="text-warm-600 hover:text-warm-700 text-base font-medium" data-tracking-id="link-e7f382e965d359b7">
                yphilipos@gmail.com
              </a>
            </div>

            {/* Location */}
            <div className="bg-sage-50 rounded-2xl p-8 text-center">
              <div className="w-14 h-14 bg-sage-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-serif font-semibold text-sage-800 mb-2">Location</h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                In-Person in Redwood City, CA<br />
                <span className="text-sage-600">Serving South Bay & Silicon Valley</span><br />
                Online Throughout California
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-serif text-sage-800 mb-2 text-center">Send a Message</h2>
            <p className="text-gray-600 text-center mb-8">Fill out the form below and I'll get back to you within 24-48 hours.</p>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Name *
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent" />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent" />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                  Subject *
                </label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent" />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message *
                </label>
                <textarea id="message" name="message" rows={6} value={formData.message} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sage-500 focus:border-transparent"></textarea>
              </div>

              <div className="text-center">
                <button type="submit" className="px-8 py-4 bg-sage-600 text-white rounded-full text-lg font-semibold hover:bg-sage-700 transition-all duration-300 hover:shadow-lg" data-tracking-id="btn-4227d320be006e0d">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>;
}
export default ContactPage;